const SKIP_PII_SUBDOMAINS = ['quinnemanuel']

export const useSkipPii = () => {
  const brand = useBrand()

  const shouldSkipPii = computed(() => SKIP_PII_SUBDOMAINS.includes(brand.value?.subdomain ?? ''))

  return { shouldSkipPii }
}
